import { AlertTriangle } from 'lucide-react';
import type { JSX } from 'react';

import styles from './OnboardingProgress.module.scss';
import type { TenantOnboarding } from '../api/tenants.graphql';

/** OS-1718 — chip de onboarding estancado (más de 7 días con menos de 50 %). */
export function StalledOnboardingChip(): JSX.Element {
  return (
    <span className={styles.stalledChip} title="Más de 7 días desde el alta con menos de 50 %">
      <AlertTriangle size={12} aria-hidden="true" />
      Estancado
    </span>
  );
}

/**
 * OS-1718 — barra de progreso de onboarding. El porcentaje y "N de 7 pasos" van en texto: el color
 * (verde completo, rojo estancado) no es la única señal.
 */
export function OnboardingProgress({
  onboarding,
  label,
}: {
  onboarding: TenantOnboarding;
  /** Nombre accesible de la barra (p. ej. "Onboarding de Palos de Leña"). */
  label: string;
}): JSX.Element {
  const tone = onboarding.complete ? styles.complete : onboarding.stalled ? styles.stalled : '';
  return (
    <div className={styles.progress}>
      <div
        className={styles.track}
        role="progressbar"
        aria-label={label}
        aria-valuemin={0}
        aria-valuemax={100}
        aria-valuenow={onboarding.percent}
        aria-valuetext={`${onboarding.percent} %, ${onboarding.completedSteps} de ${onboarding.totalSteps} pasos`}
      >
        <div className={`${styles.fill} ${tone ?? ''}`} style={{ width: `${onboarding.percent}%` }} />
      </div>
      <span className={styles.percent}>
        {onboarding.percent} % · {onboarding.completedSteps}/{onboarding.totalSteps}
      </span>
      {onboarding.stalled ? <StalledOnboardingChip /> : null}
    </div>
  );
}
